import { createStyles, Theme } from '@material-ui/core/styles'

const styles = ({ breakpoints, zIndex }: Theme) => createStyles({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
    textAlign: 'left',
    justifyContent: 'start',
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    // [breakpoints.up('md')]: {
      display: 'none',
    // },
  },
  appBar: {
    position: 'relative',
    zIndex: zIndex.appBar,
  },
});

export default styles;
